import {creates, hoistCmp} from '@xh/hoist/core';
import {NewsWidgetModel} from './NewsWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';

export const newsWidget = hoistCmp.factory({
    model: creates(() => NewsWidgetModel),
    render({model}) {
        return panel({
            item: grid({agOptions: {animateRows: true}}),
            mask: 'onLoad'
        });
    }
});
